import * as React from 'react';
import { Icon } from '@salecycle/ui-component-library';
import styled from 'styled-components';

interface OwnProps {
  color?: string;
  icon?: string;
  text?: string;
}

export type Props = OwnProps;

const StyledLabel = styled.span<Props>`
  color: ${({ color }) => color};
  padding-left: 1rem;
`;

export const IconLabel: React.FC<Props> = props => {
  return (
    <div>
      <Icon icon={props.icon} color={props.color} />
      <StyledLabel color={props.color}>{props.text}</StyledLabel>
    </div>
  );
};
